import React, { useState } from 'react';

import { Grid, Button, Modal, TextField } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Alert } from '@material-ui/lab';

import { COLOR_PRIMARY } from 'src/utils/const';
import { callApi } from 'src/core/callApi';
import { Box, Typography } from '@mui/material';

const useStyles = makeStyles((theme: Theme) => ({
  modalContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(0, 0, 0, 0.1)',
  },
  button: {
    borderRadius: 100,
    padding: '5px auto',
    outline: 'none',
    textTransform: 'capitalize',
    marginTop: 16,
    width: '45%',
    fontSize: '18px',
    fontWeight: 'bold',
  },
}));

const EditTailoredRegionNameModal = ({
  editTailoredRegionName,
  setEditTailoredRegionName,
  tailorRegionName,
  setTailorRegionName,
}) => {
  const classes = useStyles();
  const [tempTailorRegionName, setTempTailorRegionName] = useState('');
  const [loading, setLoading] = useState(false);
  const [editTailorRegionNameAlert, setEditTailorRegionNameAlert] = useState<boolean>(false);
  const [wrongTailorRegionNameAlert, setWrongTailorRegionNameAlert] = useState<boolean>(false);

  const updateTailoredRegionName = async (newTailorRegionName: string) => {
    setLoading(true);

    // tailor region name should only contain alphanumeric characters, spcace, comma, hyphen, and underscore
    if (newTailorRegionName.match(/[^a-zA-Z0-9,-_ ]/g) || newTailorRegionName.includes('/')) {
      setWrongTailorRegionNameAlert(true);
      setLoading(false);
      return;
    }

    const editTailorRegionName =
      'https://oz287au41h.execute-api.us-east-2.amazonaws.com/default/createTailorRegion';

    const editTailorRegionConfig = {
      queryParams: {
        generatedName: tailorRegionName,
        customName: newTailorRegionName,
      },
    };

    try {
      const editTailorRegionResponse = await callApi(
        editTailorRegionName,
        editTailorRegionConfig,
        true
      );
      const editTailorRegionResponseObj = editTailorRegionResponse.message;
      const isCustomNameAllowed: boolean = editTailorRegionResponseObj.isCustomNameAllowed;
      if (isCustomNameAllowed) {
        setEditTailorRegionNameAlert(false);
        setTailorRegionName(tempTailorRegionName);
        setEditTailoredRegionName(false);
      } else {
        setEditTailorRegionNameAlert(true);
      }
    } catch (e) {
      console.log('Error while calling /createTailorRegion is', e);
    }
    setLoading(false);
  };

  return (
    <>
      <Modal open={editTailoredRegionName} className={classes.modalContainer}>
        <Box
          sx={{
            width: '70vw',
            maxWidth: '400px',
            bgcolor: '#fff',
            boxShadow: 24,
            p: 4,
            borderRadius: '20px',
            animation: 'fade-scale-in 0.3s ease forwards',
          }}
        >
          <Typography variant="h5">Name Tailored Region</Typography>
          <TextField
            id="tailoredRegionName"
            label="Region Name"
            variant="standard"
            size="small"
            fullWidth
            defaultValue={tempTailorRegionName}
            value={tempTailorRegionName}
            onChange={e => setTempTailorRegionName(e.target.value)}
            type="text"
          />

          {editTailorRegionNameAlert && <Alert severity="error">Region Name already exists!</Alert>}
          {wrongTailorRegionNameAlert && (
            <Alert severity="error">
              Only alphanumeric characters, space, comma, '-', and '_' are allowed!
            </Alert>
          )}

          <Grid container item direction="row" justify="space-between" alignItems="center">
            <Button
              size="small"
              variant="contained"
              disabled={loading}
              className={classes.button}
              style={{
                background: '#fff',
                color: COLOR_PRIMARY,
                border: `1px solid ${COLOR_PRIMARY}`,
              }}
              onClick={() => setEditTailoredRegionName(false)}
            >
              Cancel
            </Button>
            <Button
              size="small"
              variant="contained"
              disabled={loading}
              className={classes.button}
              style={{
                background: COLOR_PRIMARY,
                color: '#fff',
                border: 'none',
              }}
              onClick={() => {
                updateTailoredRegionName(tempTailorRegionName);
              }}
            >
              Continue
            </Button>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};

export default EditTailoredRegionNameModal;
